export function useSimpleScroll() {
  const scrollToTop = () => {
    const scrollElement = document.documentElement || document.body;

    setTimeout(() => {
      scrollElement.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, 0);
  };

  return {
    scrollToTop,
  };
}
